import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshService } from 'app/core/services/refresh.service';

@Component({
  selector: 'dialog-definition',
  templateUrl: './dialog-definition.component.html',
  styleUrls: ['./dialog-definition.component.scss']
})
export class DialogDefinitionComponent implements OnInit {
  
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDefinitionComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private payrollDefinitionService: PayrollDefinitionService,
              private refreshService: RefreshService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDefinition() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteDefinition(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close();
        this.refreshService.emitRefresh(this.data.index);
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }
}
